import {
  FOOD_DIARY_FETCH,
  FOOD_DIARY_FETCH_TYPE,
  FOOD_DIARY_ADD,
  FOOD_DIARY_ADD_FOR_LITTER,
  FOOD_DIARY_UPDATE,
  FOOD_DIARY_DELETE,
  AUTH_LOG_OUT_USER,
  TRANSFERS_UPDATE_PET_AND_TRANSFER,
} from "actions/types";
import { AUTH_LOG_OUT_PROVIDER } from "containers/auth/Pet_Services_Portal/actions";
import _ from "lodash";

const INITIAL_STATE = {
  entries: [],
  fetchType: "",
  fetchDates: "",
  lastFetchPetID: "",
};

export default function FoodDiaryReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FOOD_DIARY_FETCH:
      return {
        ...state,
        entries: _.sortBy(action.payload, "date").reverse(),
        lastFetchPetID: action.pet._id,
      };
    case FOOD_DIARY_FETCH_TYPE:
      return {
        ...state,
        fetchDates: action.payload.dates,
        fetchType: action.payload.type,
      };
    case FOOD_DIARY_ADD:
      return {
        ...state,
        entries: _.sortBy([...state.entries, action.payload], "date").reverse(),
        fetchDates: "",
      };
    case FOOD_DIARY_ADD_FOR_LITTER:
      return {
        ...state,
        entries: _.sortBy(
          [...state.entries, ...action.payload],
          "date"
        ).reverse(),
        fetchDates: "",
      };
    case FOOD_DIARY_UPDATE:
      return {
        ...state,
        entries: _.sortBy(
          [
            ...state.entries.filter(
              (entry) => entry._id !== action.payload._id
            ),
            action.payload,
          ],
          "date"
        ).reverse(),
      };
    case FOOD_DIARY_DELETE:
      return {
        ...state,
        entries: state.entries.filter((entry) => entry._id !== action.payload),
      };
    case TRANSFERS_UPDATE_PET_AND_TRANSFER:
    case AUTH_LOG_OUT_USER:
    case AUTH_LOG_OUT_PROVIDER:
      return INITIAL_STATE;
    default:
      return state;
  }
}
